import { Button } from '@components/Button';
import CardGridWithMobileCarousel from '@components/CardGridWithMobileCarousel';
import {
  CarouselCtaWrapper,
  CarouselHeaderWrapper,
  CarouselHeadline,
} from '@components/CardGridWithMobileCarousel/style';
import { Block } from '@components/Layout';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import NullResultsNewestListings from '@components/NullResults/NewestListings';
import PropertyCard from '@components/PropertiesSearch/PropertyCard';
import { convertQueryParamsToListingFilters } from '@components/PropertiesSearch/utils';
import { ListingFilters, ListingSortKeys, SortDir } from '@engelvoelkersamericas/api';
import { useAction } from '@util/customHooks/useAction';
import { apiClient } from 'api-client';
import { observer } from 'mobx-react-lite';
import { useStores } from 'mobx/useStores';
import { useTranslations } from 'next-intl';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { FC } from 'react';

export interface FilteredListingSectionProps {
  header: string;
  queryParams: string;
}

const FilteredListingSection: FC<FilteredListingSectionProps> = observer(
  ({ header, queryParams }) => {
    const t = useTranslations();
    const { shopStore } = useStores();
    const { shopIds, shopPathPrefix } = shopStore;

    const { data: listingRes } = useAction({
      action: async () => {
        const params = new ReadonlyURLSearchParams(queryParams);
        const filters = convertQueryParamsToListingFilters(params, null);
        const finalFilters: ListingFilters = {
          ...filters,
          evOnly: true,
          shopIds: shopIds ?? undefined,
        };
        console.log({ queryParams, filters });
        const res = await apiClient.getListings({
          page: 1,
          size: 6,
          sortKey: ListingSortKeys.UsdListPrice,
          sortDir: SortDir.Desc,
          listingFilters: finalFilters,
        });
        return { data: res.data };
      },
      manual: false,
    });

    if (!listingRes?.listings.length) {
      return null;
    }

    return (
      <Block className="filtered-listings-section">
        <CarouselHeaderWrapper>
          <CarouselHeadline>{header}</CarouselHeadline>
        </CarouselHeaderWrapper>

        <VerticalLineSeparator />

        <CardGridWithMobileCarousel
          dataTestId={`filtered-listings-section`}
          cardType="property"
          cardArr={listingRes.listings.map((listing, i) => (
            <PropertyCard key={listing.ListingId} listing={listing} idx={i} />
          ))}
        />

        <CarouselCtaWrapper>
          <Button
            dataTestId="view-all-listings-btn"
            url={`${shopPathPrefix}/properties/our-listings?${queryParams}`}
            label={t('View All Listings')}
            variant="secondary"
            arrow={false}
          />
        </CarouselCtaWrapper>
      </Block>
    );
  },
);

export default FilteredListingSection;
